import { useState } from "react";
import InfoLayout from "../components/InfoLayout";
import usePageMeta from "../hooks/usePageMeta";
import { formatUkReg, normalizeUkReg } from "../../lib/vehicle/regValidation";

const notFoundCss = `
.not-found-wrap {
  min-height: calc(100vh - 180px);
  display: grid;
  place-items: center;
  padding: 40px 20px 68px;
  background: var(--page-bg, #f5f8e8);
  color: #171717;
  font-family: system-ui, -apple-system, sans-serif;
}
.not-found-card {
  width: min(100%, 420px);
  padding: 36px 28px 32px;
  text-align: center;
  background: #fff;
  border: 1px solid #d8dde4;
  border-radius: 20px;
  box-shadow: 0 16px 44px rgba(23, 23, 23, 0.08);
}
.not-found-brand {
  display: inline-flex;
  align-items: baseline;
  margin: 0 0 8px;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-decoration: none;
  color: #171717;
}
.not-found-brand .reg {
  color: var(--brand-blue, #1f6fff);
}
.not-found-img-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px auto 8px;
}
.not-found-img {
  width: 168px;
  height: 168px;
  max-width: 100%;
  object-fit: contain;
  display: block;
}
.not-found-card h1 {
  margin: 0 0 10px;
  font-size: 1.55rem;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: #171717;
}
.not-found-card p.not-found-lead {
  margin: 0 auto 22px;
  max-width: 32ch;
  color: #5f676f;
  line-height: 1.55;
  font-size: 0.98rem;
}
.not-found-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  color: #fff;
  background: var(--brand-blue, #1f6fff);
  box-shadow: 0 8px 20px rgba(31, 111, 255, 0.22);
}
.not-found-btn:hover {
  filter: brightness(1.05);
}

.v-notfound-shell {
  max-width: 720px;
  margin: 0 auto;
  padding: 36px 18px 68px;
  font-family: system-ui, -apple-system, sans-serif;
}
.v-notfound-hero {
  background: #fff;
  border: 1px solid #e5e9f0;
  border-radius: 20px;
  padding: 32px 28px;
  box-shadow: 0 12px 32px rgba(17, 24, 39, 0.05);
}
.v-notfound-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(31, 111, 255, 0.1);
  color: var(--brand-blue, #1f6fff);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.v-notfound-plate-wrap {
  margin: 12px 0 16px;
}
.v-notfound-hero h1 {
  font-size: clamp(24px, 4.5vw, 32px);
  line-height: 1.15;
  /* The page-wide heading style is too tight for this font and runs words together. */
  letter-spacing: -0.01em;
  word-spacing: normal;
  margin: 0 0 12px;
  font-weight: 800;
  color: #111827;
}
.v-notfound-hero h1 .reg {
  font-family: "Charles Wright", monospace;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.v-notfound-lead {
  font-size: 15px;
  line-height: 1.55;
  color: #4b5563;
  margin: 0 0 20px;
  max-width: 560px;
}
.v-notfound-plate {
  display: inline-flex;
  align-items: stretch;
  height: 52px;
  background: #f4d45a;
  border: 2px solid #111827;
  border-radius: 10px;
  overflow: hidden;
}
.v-notfound-plate-band {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 2px;
  width: 42px;
  flex: 0 0 42px;
  padding: 4px 0;
  background: #0e3580;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1;
}
.v-notfound-plate-band img {
  display: block;
  width: 22px;
  height: 14px;
}
.v-notfound-plate-text {
  display: inline-flex;
  align-items: center;
  padding: 0 18px;
  font: 700 26px/1 "Charles Wright", monospace;
  letter-spacing: 1.2px;
  color: #111;
  white-space: nowrap;
}
.v-notfound-search-card {
  margin-top: 22px;
  background: #111827;
  color: #fff;
  border-radius: 18px;
  padding: 22px;
}
.v-notfound-search-card h2 {
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #fff;
}
.v-notfound-search-card > p {
  font-size: 13.5px;
  color: #cbd3da;
  margin: 0 0 14px;
}
.v-notfound-form {
  display: flex;
  flex-wrap: nowrap;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.v-notfound-form.is-busy .v-notfound-nf-plate {
  max-width: none;
  flex: 1 1 auto;
  width: 100%;
}
.v-notfound-nf-plate {
  display: inline-flex;
  align-items: stretch;
  height: 52px;
  background: #f4d45a;
  border: 2px solid #111827;
  border-radius: 10px;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 200px;
  max-width: 273px;
  transition: max-width .15s ease;
}
.v-notfound-nf-input {
  appearance: none;
  border: 0;
  outline: 0;
  background: transparent;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  padding: 0 9px 0 16px;
  font: 700 22px/1 "Charles Wright", monospace;
  letter-spacing: 1.2px;
  color: #111;
  text-transform: uppercase;
}
.v-notfound-nf-input::placeholder {
  color: rgba(55, 60, 48, 0.48);
}
.v-notfound-btn {
  flex: 0 0 auto;
  margin-left: auto;
  height: 52px;
  padding: 0 20px;
  border: 0;
  border-radius: 999px;
  background: var(--brand-blue, #1f6fff);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: min-width .15s ease, width .15s ease, padding .15s ease;
}
.v-notfound-btn:hover {
  filter: brightness(1.05);
}
.v-notfound-btn.is-busy {
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  padding: 0;
  pointer-events: none;
  cursor: wait;
}
.v-notfound-btn .cta-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 999px;
  animation: cta-spin .7s linear infinite;
}
@keyframes cta-spin {
  to { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .v-notfound-btn .cta-spinner {
    animation: none;
    border-right-color: currentColor;
    opacity: .55;
  }
}
@media (max-width: 520px) {
  .v-notfound-nf-plate,
  .v-notfound-btn {
    height: 46px;
  }
  .v-notfound-nf-plate {
    max-width: none;
  }
  .v-notfound-plate-band,
  .v-notfound-nf-plate .v-notfound-plate-band {
    width: 34px;
    flex-basis: 34px;
    font-size: 9px;
  }
  .v-notfound-nf-input {
    font-size: 18px;
  }
  /* Stack the plate and button so the button never spills out of the card. */
  .v-notfound-form {
    flex-wrap: wrap;
    gap: 10px;
  }
  .v-notfound-nf-plate {
    flex: 1 1 100%;
    min-width: 0;
  }
  .v-notfound-btn {
    flex: 1 1 100%;
    margin-left: 0;
  }
  .v-notfound-btn.is-busy {
    width: 100%;
    max-width: none;
  }
}
`;

function VehicleNotFoundView({ brand, rawReg }) {
  const [searchVrm, setSearchVrm] = useState("");
  const [busy, setBusy] = useState(false);
  const cleanReg = normalizeUkReg(rawReg);
  const displayReg = cleanReg ? (formatUkReg(cleanReg) || cleanReg) : "";
  const isLad = brand.key === "servicelad";

  const handleSearch = (e) => {
    e.preventDefault();
    const clean = normalizeUkReg(searchVrm);
    if (!clean || busy) return;
    setBusy(true);
    window.location.href = `/vehicle/${clean.toLowerCase()}`;
  };

  return (
    <InfoLayout brand={brand}>
      <style>{notFoundCss}</style>
      <div className="v-notfound-shell" style={{ "--brand-blue": brand.accent || "#1f6fff" }}>
        <section className="v-notfound-hero">
          <span className="v-notfound-tag">Registration lookup</span>

          {displayReg && (
            <div className="v-notfound-plate-wrap">
              {isLad ? (
                <div className="v-notfound-plate" aria-label={`Registration ${displayReg}`}>
                  <span className="v-notfound-plate-band" aria-hidden="true">
                    <img src="/gb-flag.svg" alt="" width="22" height="14" />
                    UK
                  </span>
                  <span className="v-notfound-plate-text">{displayReg}</span>
                </div>
              ) : (
                <div style={{ display: "inline-flex", alignItems: "center", padding: "8px 18px", background: "#f7d54a", border: "2px solid #111", borderRadius: "8px", font: "700 24px/1 'Charles Wright', monospace", letterSpacing: "1.2px", color: "#111" }}>
                  {displayReg}
                </div>
              )}
            </div>
          )}

          <h1>{displayReg ? <>No vehicle record found for <span className="reg">{displayReg}</span></> : "Vehicle registration not found"}</h1>
          <p className="v-notfound-lead">
            {displayReg
              ? "We could not find an official DVLA or MOT record for this registration. It may contain a typo, or the vehicle might not be recorded on the public register yet."
              : "Enter a valid UK registration to look up official tax and MOT information."}
          </p>

          <div className="v-notfound-search-card">
            <h2>Check another registration</h2>
            <p>Enter any UK registration to search official tax and MOT records.</p>
            <form className={`v-notfound-form${busy ? " is-busy" : ""}`} onSubmit={handleSearch}>
              {isLad ? (
                <div className="v-notfound-nf-plate">
                  <span className="v-notfound-plate-band" aria-hidden="true">
                    <img src="/gb-flag.svg" alt="" width="22" height="14" />
                    UK
                  </span>
                  <input
                    className="v-notfound-nf-input"
                    name="vrm"
                    maxLength={8}
                    autoComplete="off"
                    spellCheck="false"
                    aria-label="UK registration"
                    placeholder="ENTER REG"
                    value={searchVrm}
                    onChange={(e) => setSearchVrm(e.target.value.toUpperCase())}
                    required
                  />
                </div>
              ) : (
                <input
                  style={{ background: "#f7d54a", border: "2px solid #111", borderRadius: "8px", padding: "10px 16px", font: "700 22px/1 'Charles Wright', monospace", textTransform: "uppercase", color: "#111", minWidth: "170px", letterSpacing: "1.2px" }}
                  name="vrm"
                  maxLength={8}
                  autoComplete="off"
                  spellCheck="false"
                  aria-label="UK registration"
                  placeholder="ENTER REG"
                  value={searchVrm}
                  onChange={(e) => setSearchVrm(e.target.value.toUpperCase())}
                  required
                />
              )}
              <button type="submit" className={`v-notfound-btn${busy ? " is-busy" : ""}`} disabled={busy} aria-busy={busy}>
                {busy ? <span className="cta-spinner" aria-hidden="true" /> : "Check vehicle"}
              </button>
            </form>
          </div>
        </section>
      </div>
    </InfoLayout>
  );
}

function NormalNotFoundView({ brand }) {
  const brandLead = brand.name.replace(/Reg|Boss|Lad/i, "");
  const brandSuffix = brand.name.replace(brandLead, "");

  return (
    <InfoLayout brand={brand}>
      <style>{notFoundCss}</style>
      <section className="not-found-wrap" style={{ "--brand-blue": brand.accent || "#1f6fff" }}>
        <div className="not-found-card">
          <a className="not-found-brand" href="/" aria-label={`${brand.name} home`}>
            {brandLead}<span className="reg">{brandSuffix}</span>
          </a>

          <div className="not-found-img-wrap">
            <img src="/svgs/404.png" alt="" className="not-found-img" width="168" height="168" />
          </div>

          <h1>Page not found</h1>
          <p className="not-found-lead">
            That page is not on {brand.name}. The link may be out of date.
          </p>

          <a className="not-found-btn" href="/">
            Back to home
          </a>
        </div>
      </section>
    </InfoLayout>
  );
}

export default function NotFoundPage({ brand }) {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const vehicleMatch = pathname.match(/^\/vehicle(?:\/([a-z0-9]+))?\/?$/i);

  const rawReg = vehicleMatch ? (vehicleMatch[1] || "") : "";
  const cleanReg = normalizeUkReg(rawReg);
  const displayReg = cleanReg ? (formatUkReg(cleanReg) || cleanReg) : "";

  usePageMeta({
    title: vehicleMatch
      ? (displayReg ? `No vehicle record found for ${displayReg} | ${brand.name}` : `Vehicle not found | ${brand.name}`)
      : `Page not found | ${brand.name}`,
    description: vehicleMatch
      ? (displayReg ? `We could not find an official DVLA or MOT record for ${displayReg} on ${brand.name}.` : `Search UK registrations to find official tax and MOT information on ${brand.name}.`)
      : `That page is not available on ${brand.name}.`,
    robots: "noindex, follow",
  });

  if (vehicleMatch) {
    return <VehicleNotFoundView brand={brand} rawReg={rawReg} />;
  }

  return <NormalNotFoundView brand={brand} />;
}
